import { useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import GridCard from "../Cards/GridCard";
import MKBox from "../../components/MKBox";
import MyBar from "../Charts/myBar";
import MyLine from "../Charts/myLine";
import MKTypography from "../../components/MKTypography";
import MyStackedBar from "../Charts/myStackedBar";
import MyPercentPie from "../Charts/myPercentPie";
import MyPercentArea from "../Charts/myPercentArea";

const GridCardChartAnalysis = ({ productionInfo }) => {
  const parentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);
  const [chartHeight, setchartHeight] = useState(null);

  const { charts } = useSelector((state) => state.returnChart);
  const analysisCharts =
    charts !== [] ? charts.filter((c) => c.analysis === productionInfo.id) : [];
  // console.log(analysisCharts);
  useLayoutEffect(() => {
    if (parentRef.current) {
      const parentHeight = parentRef.current.offsetHeight;
      const parentWidth = parentRef.current.offsetWidth;
      const titleHeight = parentRef.current ? parentRef.current.children[0].offsetHeight : 50;
      setMaxHeight(parentHeight - titleHeight - 48);
      setchartHeight(parentWidth - 36);
    }
  }, [parentRef]);
  return (
    <>
      <GridCard title={productionInfo.summaries.chart_title} ref={parentRef}>
        {analysisCharts !== [] ? (
          <MKBox sx={{ maxHeight, height: 1, width: 1, p: { lg: 0, xl: 1 } }}>
            {analysisCharts.map((chart) =>
              chart.chart === "line" ? (
                <MKBox key={chart.title}>
                  <MKTypography
                    textTransform="capitalize"
                    sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}
                  >
                    {chart.title}
                  </MKTypography>
                  <MKBox
                    key={chart.title}
                    sx={{
                      height: chartHeight,
                    }}
                  >
                    <MyLine
                      data={chart.data}
                      width={chartHeight}
                      yunit={chart.yunit ? chart.yunit : "km²"}
                    />
                  </MKBox>
                </MKBox>
              ) : null
            )}
            {analysisCharts.map((chart) =>
              chart.chart === "bar" ? (
                <MKBox key={chart.title}>
                  <MKTypography
                    textTransform="capitalize"
                    sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}
                  >
                    {chart.title}
                  </MKTypography>
                  <MKBox
                    key={chart.title}
                    sx={{
                      height: chartHeight,
                    }}
                  >
                    <MyBar
                      data={chart.data}
                      width={chartHeight}
                      yunit={chart.yunit ? chart.yunit : "km²"}
                    />
                  </MKBox>
                </MKBox>
              ) : null
            )}
            {analysisCharts.map((chart) =>
              chart.chart === "stacked_bar" ? (
                <MKBox key={chart.title}>
                  <MKTypography
                    textTransform="capitalize"
                    sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}
                  >
                    {chart.title}
                  </MKTypography>
                  <MKBox
                    key={chart.title}
                    sx={{
                      height: chartHeight,
                    }}
                  >
                    <MyStackedBar
                      data={chart.data}
                      width={chartHeight}
                      yunit={chart.yunit ? chart.yunit : "km²"}
                    />
                  </MKBox>
                </MKBox>
              ) : null
            )}
            {analysisCharts.map((chart) =>
              chart.chart === "percent_area" ? (
                <MKBox key={chart.title}>
                  <MKTypography
                    textTransform="capitalize"
                    sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}
                  >
                    {chart.title}
                  </MKTypography>
                  <MKBox
                    key={chart.title}
                    sx={{
                      height: chartHeight,
                    }}
                  >
                    <MyPercentArea
                      data={chart.data}
                      width={chartHeight}
                      yunit={chart.yunit ? chart.yunit : "%"}
                    />
                  </MKBox>
                </MKBox>
              ) : null
            )}
            {analysisCharts.map((chart) =>
              chart.chart === "percent_pie" ? (
                <MKBox key={chart.title}>
                  <MKTypography
                    textTransform="capitalize"
                    sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}
                  >
                    {chart.title}
                  </MKTypography>
                  <MKBox
                    key={chart.title}
                    sx={{
                      height: chartHeight,
                    }}
                  >
                    <MyPercentPie data={chart.data} width={chartHeight} />
                  </MKBox>
                </MKBox>
              ) : null
            )}
          </MKBox>
        ) : null}
      </GridCard>
    </>
  );
};
GridCardChartAnalysis.defaultProps = {};

GridCardChartAnalysis.propTypes = {
  productionInfo: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
export default GridCardChartAnalysis;
